<div class="privacy-modal">
    <motif-modal-title class="title" variant="alt">
        <div class="header-container">
            <motif-icon size="30" class="motif-icon" [iconFunction]="privacyPolicyIcon"></motif-icon>
            <h2 class="header-title">
                {{ "PrivacyPolicy" | translate }}
            </h2>
        </div>

        <button *ngIf="isVisible" motifIconButton aria-label="Close modal" [motif-modal-close]="true"
            [size]="buttonSizes.LARGE">
            <motif-icon class="motif-modal-header-close-icon" [iconFunction]="closeIcon"></motif-icon>
        </button>
    </motif-modal-title>
    <motif-modal-content #modalContent>

        <div class="privacy-notice-content">
            <h3>Privacy Notice – PM Pro</h3>
            <h3>1. Introduction</h3>
            <p>This Privacy Notice is intended to describe the practices EY follows in relation to the PM Pro (“Tool”)
                with respect to the privacy of all individuals whose personal data is processed and stored in the Tool.
                This Privacy Notice should be read together with the <a
                    href="https://www.ey.com/en_gl/privacy-statement" target="_blank">ey.com/Privacy Statement</a>, and
                in case of any
                conflict with the <a href="https://www.ey.com/en_gl/privacy-statement" target="_blank">ey.com/Privacy
                    Statement</a>, the terms of this Privacy Notice will prevail. Please read
                this Privacy Notice carefully.</p>

            <h3>2. Who manages the Tool?</h3>
            <p>“EY” refers to one or more of the member firms of Ernst & Young Global Limited (“EYG”) each of which is a
                separate legal entity and can determine the purposes and means for data processing in its own right
                (i.e., act as a data controller or in a similar capacity).</p>
            <p>The entity that is acting as data controller (or similar capacity) by providing this Tool on which your
                personal data will be processed and stored is:</p>
            <ul>
                <li>For the personal data of EY personnel: The data controller is the EY entity which employs you.</li>
                <li>For the personal data of third-party personnel (including EY clients): The data controller is the EY
                    local member firm with which the third party has a relationship.</li>
            </ul>
            <p>You can find a list of local EY member firms and affiliates on the <a
                    href="https://www.ey.com/en_gl/privacy-statement" target="_blank">ey.com/Privacy Statement</a>. The
                personal
                data in the Tool is shared by the above data controller with one or more member firms of EYG (see “Who
                can access your personal data” section 6 below).</p>
            <p>The Tool is hosted externally on servers in an EY Managed MS Azure Data Center, the location of which
                will be selected based on the client’s region. Location’s details can be found here <a
                    href="https://datacenters.microsoft.com/globe/explore"
                    target="_blank">https://datacenters.microsoft.com/globe/explore</a>.</p>

            <h3>3. How does the Tool process personal data?</h3>
            <p>The Tool is used to effectively manage projects’ tasks, resources, time, risks, reporting, communication,
                analysis and work plans.</p>
            <p>Your data processed in the Tool is used as follows: individual’s full name and email address are utilized
                for user authentication, login and maintaining system logs.</p>
            <p>EY relies on the following basis to legitimize the processing of your personal data in the Tool:
                Processing of your personal data is necessary for the purposes of the legitimate interests pursued by
                the data controller or by a third party, except where such interests are overridden by the interests or
                fundamental rights and freedoms of the data subject which require protection of personal data. The
                specific legitimate interest is conducting client engagements.</p>
            <p>You have the right to object at any time, on grounds relating to your particular situation, to the
                processing of personal data concerning you based on the above legitimate interest(s).</p>
            <p>We process your personal data based on your consent. The provision of your personal data to EY is
                optional. However, if you do not provide all or part of your personal data, we may be unable to carry
                out the purposes for processing. You have the right to withdraw your consent at any time.</p>

            <h3>4. What type of personal data is processed in the Tool?</h3>
            <p>The Tool processes these personal data categories:</p>
            <ul>
                <li>EY individuals:
                    <ul class="mg-btm">
                        <li>Full name.</li>
                        <li>Email address.</li>
                    </ul>
                </li>
                <li>Client individuals:
                    <ul class="mg-btm">
                        <li>Full name.</li>
                        <li>Email address.</li>
                    </ul>
                </li>
            </ul>
            <p>This data is sourced from:</p>
            <ul>
                <li>EY individuals: Active Directory.</li>
                <li>Client individuals: MyEY.</li>
            </ul>

            <h3>5. Sensitive personal data</h3>
            <p>Sensitive personal data reveals your racial or ethnic origin, political opinions, religious or
                philosophical beliefs, trade union membership, genetic data, biometric data, data concerning health or
                data concerning sex life or sexual orientation.</p>
            <p>EY does not intentionally collect any sensitive personal data from you via the Tool. The Tool’s intention
                is not to process such information.</p>

            <h3>6. Who can access your personal data?</h3>
            <p>Your personal data is accessed in the Tool by the following persons/teams:</p>
            <ul>
                <li>FAAS Business team – internal EY.</li>
                <li>FAAS Support team – internal EY.</li>
                <li>AMS Support Team (CT) – internal EY.</li>
                <li>Clients.</li>
            </ul>
            <h3>Access Rights Table</h3>
            <table>
                <thead>
                    <tr class="headertable">
                        <th>USER GROUP</th>
                        <th>LOCATION</th>
                        <th>PURPOSE</th>
                        <th>ACCESS</th>
                        <th>AMOUNT</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>FAAS support team</td>
                        <td>India</td>
                        <td>Technical support for the entire platform</td>
                        <td>All</td>
                        <td>20</td>
                    </tr>
                    <tr>
                        <td>FAAS business team</td>
                        <td>Global</td>
                        <td>Client support with data and presentation issues</td>
                        <td>All</td>
                        <td>20+</td>
                    </tr>
                    <tr>
                        <td>AMS Support team (CT)</td>
                        <td>India</td>
                        <td>Troubleshooting</td>
                        <td>All</td>
                        <td>5 - 8</td>
                    </tr>
                    <tr>
                        <td>EY Client Serving Professional</td>
                        <td>Global</td>
                        <td>View Power BI</td>
                        <td>All for MS Azure</td>
                        <td>100</td>
                    </tr>
                </tbody>
            </table>
            <p>The access rights detailed above involves transferring personal data in various jurisdictions (including
                jurisdictions outside the European Union) in which EY operates (EY office locations are listed at here
                <a href="https://www.ey.com/en_gl/locations" target="_blank">https://www.ey.com/en_gl/locations</a>). An
                overview of EY network entities providing
                services to external clients is accessible <a href="https://www.ey.com/en_uk/legal-statement" target="_blank"> here</a> (See Section 2 (About EY) - “View a list of EY member
                firms and affiliates”). EY will process your personal data in the Tool in accordance with applicable law
                and professional regulations in your jurisdiction. Transfers of personal data within the EY network are
                governed by EY’s <a href="https://www.ey.com/en_gl/data-protection-binding-corporate-rules-program"
                    target="_blank">Binding Corporate Rules.</a>
            </p>
            <p>We transfer or disclose the personal data we collect to third-party service providers (and their
                subsidiaries and affiliates) who are engaged by us to support our internal ancillary processes. For
                example, we engage service providers to provide, run and support our IT infrastructure (such as identity
                management, hosting, data analysis, back-up, security and cloud storage services) and for the storage
                and secure disposal of our hard copy files. It is our policy to only use third-party service providers
                that are bound to maintain appropriate levels of data protection, security and confidentiality, and that
                comply with any applicable legal requirements for transferring personal data outside the jurisdiction in
                which it was originally collected.</p>
            <p>To the extent that personal data has been rendered anonymous in such a way that you or your device are no
                longer reasonably identifiable, such information will be treated as non-personal data and the terms of
                this Privacy Notice will not apply.</p>
            <p>For data collected in the European Economic Area (EEA) or which relates to individuals in the EEA, EY
                requires an appropriate transfer mechanism as necessary to comply with applicable law. The transfer of
                personal data from the Tool to Microsoft is governed by an agreement between EY and the service provider
                that includes standard data protection clauses adopted by the European Commission.</p>

            <h3>7. Data retention</h3>
            <p>Our policy is to retain personal data only for as long as it is needed for the purposes described in the
                section “How does the Tool process personal data”. Retention periods vary in different jurisdictions and
                are set in accordance with local regulatory and professional retention requirements.</p>
            <p>In order to meet our professional and legal requirements, to establish, exercise or defend our legal
                rights and for archiving and historical purposes, we need to retain information for significant periods
                of time.</p>
            <p>The policies and/or procedures for the retention of personal data in the Tool are: The total retention
                period is defined and will be implemented in accordance with the <a href="https://find.ey.net/discover/sitepages/home.aspx?detailPath=ZYFCSFS674FF-4-3034#detailPath=ZYFCSFS674FF-4-3034" target="_blank"> EY Records Retention Global Policy</a> and
                the relevant <a href="https://ig2.ironmountainconnect.com/ey/p/grs/section/country-retention-schedules" target="_blank">Country Retention Schedule(CRS)</a>. 
                Log Data will be retained in accordance with the <a href="https://sites.ey.com/sites/informationsecurity/Policy Library/Logging_Policy.pdf" target="_blank" >EY IT
                Logging Policy.</a> </p>
            <p>After the end of the data retention period, your personal data will be deleted.</p>

            <h3>8. Security</h3>
            <p>EY protects the confidentiality and security of information it obtains in the course of its business.
                Access to such information is limited, and policies and procedures are in place that are designed to
                safeguard the information from loss, misuse and improper disclosure. Additional information regarding
                our approach to data protection and information security is available in our
                <a href="https://eur01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fassets.ey.com%2Fcontent%2Fdam%2Fey-sites%2Fey-com%2Fen_gl%2Ftopics%2Fconsulting%2Fey-protecting-your-data-brochure-v2.pdf&data=05%7C01%7CEvangelia.Mavrovounioti%40uk.ey.com%7C1a4a52e2631542f349d908db4bc8f0c2%7C5b973f9977df4bebb27daa0c70b8482c%7C0%7C0%7C638187098628892489%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000%7C%7C%7C&sdata=4aVx9v7vi%2FC%2Fw7zZjni1F89TCu6LSbe8hAPrfgxxMNA%3D&reserved=0" target="_blank"> ey-protecting-your-data-brochure-v2.pdf brochure</a>.</p>

            <h3>9. Controlling your personal data</h3>
            <p>EY will not transfer your personal data to third parties (other than any external parties referred to in
                section 6 above) unless we have your permission or are required by law to do so.</p>

            <h3>10. Your rights in relation to your personal data</h3>
            <p>Depending on the applicable jurisdiction, you may have certain rights in relation to your personal data,
                including:</p>
            <ul>
                <li>To request details of the personal data EY processes about you and to access the personal data that
                    EY processes about you</li>
                <li>To have your personal data corrected, for example, if it is incomplete or incorrect</li>
                <li>To restrict or object to the processing of personal data or request the erasure of your personal
                    data</li>
                <li>To receive a copy of the personal data which you have provided to EY in a structured, commonly used
                    and machine-readable format which you can re-use for your own purposes (known as “data portability”)
                </li>
                <li>Where you have provided consent to the processing of your personal data, the right to withdraw your
                    consent.</li>
                <li>The right to complain to a data protection authority (see section “Complaints”)</li>
            </ul>

            <h3>11. Complaints</h3>
            <p>If you are concerned about an alleged breach of privacy law or any other regulation, contact EY’s Global
                Privacy Leader, Office of the General Counsel, 1 More London Place, London, SE1 2AF, United Kingdom or
                via email at <a href="mailto:global.data.protection@ey.com">global.data.protection&#64;ey.com</a> or via
                your usual EY representative. An EY Privacy Leader
                will investigate your complaint and provide information about how it will be handled and resolved.</p>
            <p>If you are not satisfied with how EY resolved your complaint, you may have the right to complain to your
                country’s data protection authority. You may also have the right to refer the matter to a court of
                competent jurisdiction.</p>
            <p>Certain EY member firms in countries outside the European Union (EU) and the UK have appointed
                representatives in the EU and the UK respectively to act on their behalf if, and when, they undertake
                data processing activities to which the EU General Data Protection Regulation (GDPR) and/or the UK
                General Data Protection Regulation (UK GDPR) applies. Further information and the contact details of
                these representatives are available below:</p>
            <p>
                <a href="https://www.ey.com/en_gl/privacy-statement#EUrepresentative" target="_blank">
                    EU data protection representative | EY
                </a>
            </p>
            <p>
                <a href="https://www.ey.com/en_gl/privacy-statement#UKrepresentative" target="_blank">
                    UK Data protection representative (ey.com)
                </a>
            </p>

            <h3>12. Contact us</h3>
            <p #listItem>If you have additional questions or concerns, contact your usual EY representative or email
                <a href="mailto:global.data.protection@ey.com">global.data.protection&#64;ey.com</a>
            </p>
        </div>

    </motif-modal-content>
    <div class="action-buttons" *ngIf="isVisible">
        <motif-modal-actions>

        </motif-modal-actions>
    </div>


    <div class="action-buttons" *ngIf="!isVisible">
        <motif-modal-actions>
            <button class="button" [ngClass]="{'actionBtn': !acceptDisabled, '': acceptDisabled}" motifButton
                color="primary" variant="stepper" type="button" aria-label="Accept" [motif-tooltip]="'Accept'"
                [hideIconClose]="true" placement="left" [disabled]="acceptDisabled" (click)="onAccept()" [motif-modal-close]="true">
                Accept
            </button>

            <button class="button" motifButton color="secondary" variant="stepper" type="button" aria-label="Decline"
                [motif-tooltip]="'Decline'" [hideIconClose]="true" (click)="onDecline()">
                Decline
            </button>
        </motif-modal-actions>
    </div>
</div>